import { render, staticRenderFns } from "./crearConsecutivo.vue?vue&type=template&id=5f4ea59a"
import script from "./crearConsecutivo.vue?vue&type=script&lang=js"
export * from "./crearConsecutivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports